import React from "react";
import {
  User, Building2, Award, Briefcase, Target, TrendingUp,
  ArrowUpRight, CheckCircle2,
} from "lucide-react";
import { C, Reveal } from "./shared";

const STEPS = [
  [User, "Student Builds Profile & Adds Skills", C.green],
  [Building2, "Institution Enables & Verifies Students", C.navy],
  [Award, "Lab Issues Verifiable Certificates", C.purple],
  [Briefcase, "Company Posts Roles & Searches Talent", C.orange],
  [Target, "Smart Matching Connects Opportunities", C.green],
  [TrendingUp, "Placements, Internships & Better Outcomes", C.navy],
];

const REASONS = [
  "Unified ecosystem for education, skills & employment",
  "Verified data for trust & transparency",
  "Improved placement & hiring efficiency",
  "Outcome-driven platform",
  "Scalable, secure & future-ready",
];

export default function HowItWorks() {
  return (
    <section className="bg-white border-t" style={{ borderColor: C.rule }}>
      <div className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-8">
          <h3 className="font-display font-extrabold text-xl tracking-wide uppercase text-center md:text-left" style={{ color: C.navy }}>
            How SkillConnect Creates Impact
          </h3>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {STEPS.map(([Icon, label, color], i, arr) => (
              <div key={label} className="group relative flex flex-col items-center text-center cursor-default" data-testid={`step-${i}`}
                style={{ animationDelay: `${i * 80}ms` }}>
                <div className="w-14 h-14 rounded-full grid place-items-center shadow-sm transition-all duration-500 group-hover:scale-110 group-hover:shadow-lg group-hover:-translate-y-1"
                  style={{ background: "white", border: `2px solid ${color}30`, color }}>
                  <Icon size={22} strokeWidth={2.2} className="transition-transform duration-500 group-hover:rotate-6" />
                </div>
                <div className="mt-3 text-[11px] font-semibold leading-tight px-1 transition-colors duration-300" style={{ color: C.ink }}>{label}</div>
                {i < arr.length - 1 && (
                  <ArrowUpRight size={14} className="hidden lg:block absolute -right-2 top-4 transition-transform duration-500 group-hover:translate-x-1" style={{ color, transform: "rotate(45deg)" }} />
                )}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={2} className="lg:col-span-4">
          <div className="rounded-2xl p-6 h-full transition-shadow duration-500 hover:shadow-xl" style={{ background: `${C.green}08`, border: `1px solid ${C.green}30` }}>
            <h3 className="font-display font-extrabold text-base tracking-wide uppercase" style={{ color: C.green }}>
              Why SkillConnect?
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              {REASONS.map((t, i) => (
                <li key={t} className="flex items-start gap-2 transition-transform duration-300 hover:translate-x-1" data-testid={`why-${i}`}>
                  <CheckCircle2 size={16} className="shrink-0 mt-0.5 transition-transform hover:scale-125" style={{ color: C.green }} />
                  <span style={{ color: C.ink }}>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
